import api from "./axios";

export const getMyProfileApi = async () => {
	const response = await api.get("/api/user/me");
	return response.data;
};

export const updateMyProfileApi = async (payload: Record<string, unknown>) => {
	const response = await api.patch("/api/user/me", payload);
	return response.data;
};

export const getProfilePictureApi = async () => {
	const response = await api.get("/api/user/profile/picture");
	return response.data;
};

export const uploadProfilePictureApi = async (file: File) => {
	const formData = new FormData();
	formData.append("file", file);
	const response = await api.post("/api/user/file/upload", formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});
	return response.data;
};

export const deleteAccountApi = async () => {
	const response = await api.delete("/api/user/me");
	return response.data;
};

export const cancelAccountDeletionApi = async () => {
	const response = await api.post("/api/user/me/cancel-deletion");
	return response.data;
};
